import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "full",
  "title": "Focus Articles",
  "lead": "In each edition of the GEM Report, the Monitoring Section provides focus articles highlighting key issues that are shaping progress towards SDG 4. Here we provide a selection of these articles related to the themes of the SCOPE website."
};
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {FocusIndex, FocusLogo, Title} = _components;
  if (!FocusIndex) _missingMdxReference("FocusIndex", true);
  if (!FocusLogo) _missingMdxReference("FocusLogo", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(FocusLogo, {}), "\n", _jsx(Title, {
      children: "Focus Articles"
    }), "\n", _jsx(_components.p, {
      children: "In each edition of the GEM Report, the Monitoring Section provides focus articles highlighting key issues that are shaping progress towards SDG 4. Here we provide a selection of these articles related to the themes of the SCOPE website."
    }), "\n", _jsx(FocusIndex, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
